'use strict';

var StrategiesFromTemplateListDirective = function StrategiesFromTemplateListDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategies-from-template-list.html'),
    controller: require('../controllers/StrategiesFromTemplateListController.js'),
    scope: {
      strategyTemplate: '=',
      closePanelHandler: '&'
    },
    link: function link(scope) {
      scope.$watch('strategyTemplate', function () {
        scope.populateStrategies();
        scope.selectDefault();
      });
      scope.$on('rules-panel:strategy-data-changed', function () {
        scope.populateStrategies();
      });
    }
  };
};
StrategiesFromTemplateListDirective.$inject = [];
module.exports = StrategiesFromTemplateListDirective;